import React, { useRef, useState } from 'react';
import ENUMS from '../../enums/index';
import Select from 'react-select';
import './styles.scss';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

const PaymentsFilter = props => {
  let formRefrence = useRef();
  let [startCreatedAtDate, setStartCreatedAtDate] = useState(' ');
  let [endCreatedAtDate, setEndCreatedAtDate] = useState(' ');
  let [isPublished, setIsPublished] = useState();
  let [isViewable, setIsViewable] = useState();
  let [publishStatus, setPublishStatus] = useState({ label: 'هردو', value: 'null' });
  let [viewStatus, setViewStatus] = useState({ label: 'هردو', value: 'null' });
  let [startPublishedAtDate, setStartPublishedAtDate] = useState(' ');
  let [endPublishedAtDate, setEndPublishedAtDate] = useState(' ');
  let [titlePart, setTitlePart] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setStartCreatedAtDate(' ');
    setEndCreatedAtDate(' ');
    setPublishStatus('null');
    setViewStatus('null');
    setIsPublished(null);
    setIsViewable(null);
    setStartPublishedAtDate(' ');
    setEndPublishedAtDate(' ');
    setTitlePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div
            className="d-flex flex-sm-column flex-md-row col-12 justify-content-around p-0 align-items-center"
            style={{ gap: '5px' }}
          >
            <div className="col-md-6 col-sm-12 d-flex justify-content-between" style={{ gap: '5px' }}>
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع ایجاد"
                onChange={val => setStartCreatedAtDate(val)}
                name="startDate"
                value={startCreatedAtDate}
                className="col-6 date-picker-input startCreatedAtDate"
              />
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان ایجاد"
                name="endDate"
                onChange={val => setEndCreatedAtDate(val)}
                value={endCreatedAtDate}
                className="col-6 date-picker-input endCreatedAtDate"
              />
            </div>
            <div className="col-md-6 col-sm-12 d-flex justify-content-between" style={{ gap: '5px' }}>
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع نشر"
                name="startPublishedAtDate"
                onChange={val => setStartPublishedAtDate(val)}
                value={startPublishedAtDate}
                className="col-6 date-picker-input startPublishedAtDate"
              />
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان نشر"
                name="endPublishedAtDate"
                onChange={val => setEndPublishedAtDate(val)}
                value={endPublishedAtDate}
                className="col-6 date-picker-input endPublishedAtDate"
              />
            </div>
          </div>
          <div className="d-flex flex-sm-column flex-md-row m-4 align-items-center px-1">
            <div className="d-flex flex-column mx-1 col-md-4 col-sm-12 h-50 py-2">
              <input
                onChange={event => setTitlePart(event.target.value)}
                value={titlePart || ''}
                name="titlePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.title')}
                maxLength={ENUMS.MAX_LENGTH.title}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.20')}</small>
            </div>
            <div className="d-flex mx-1 col-md-4 col-sm-12 h-50 py-2">
              {locales('tables.publishStatus')}
              <Select
                placeholder={locales('tables.publishStatus')}
                isMulti={false}
                name="isPublished"
                value={publishStatus}
                options={ENUMS.MESSAGE_PUBLISH_STATUS.list.map(bankName => ({
                  label: bankName.title,
                  value: bankName.value
                }))}
                onChange={selectedIds => setPublishStatus(selectedIds)}
                className="col-10"
              />
            </div>
            <div className="d-flex mx-1 col-md-4 col-sm-12 h-50 py-2">
              {locales('tables.viewStatus')}
              <Select
                placeholder={locales('tables.viewStatus')}
                isMulti={false}
                name="isViewable"
                value={viewStatus}
                options={ENUMS.MESSAGE_VIEW_STATUS.list.map(bankName => ({
                  label: bankName.title,
                  value: bankName.value
                }))}
                onChange={selectedIds => setViewStatus(selectedIds)}
                className="col-10"
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-messages" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default PaymentsFilter;
